/**
 * Opens the native share screen if available
 */
export const webShare = (shareData: globalThis.ShareData): Promise<void> => {
	if (!navigator.share) return;

	return navigator.share(shareData);
};
